<template>
  <div class="myCenter">
    <div class="myMsg" v-if="isShow">
      <div class="kailong"></div>
      <div class="head_portrait">
        <img style="width: 100%" :src="userInfo.iconImg" alt />
      </div>
      <!--<div class="user_msg">-->
      <!--<div class="name">HYUK.卡卡</div>-->
      <!--<div class="address">L2.   V3.   24岁， 陕西西安</div>-->
      <!--<div class="signature">个性签名：yoyo！traper....</div>-->
      <!--<div class="fans">粉丝 <span>5816</span> 关注 <span>84</span></div>-->
      <!--</div>-->
      <div class="user_msg">
        <div class="name">{{userInfo.realName}}</div>
        <div
          class="address"
        >L{{userInfo.userClass}}. V{{userInfo.userVipClass}}. {{userInfo.age}}岁， {{userInfo.region}}</div>
        <div
          :title="userInfo.sign"
          class="signature"
          style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer"
        >个性签名：{{userInfo.sign?userInfo.sign:'无'}}</div>
        <div class="fans">
          粉丝
          <span>{{userInfo.fansTotalNum}}</span> 关注
          <span>{{userInfo.attentionTotalNum}}</span>
        </div>
      </div>
      <div style="margin-top: 133px;">
        <el-button style="width: 200px;margin-right: 30px" @click="skipSong()">上 传 歌 曲</el-button>
        <el-button style="width: 200px" @click="skipAccompany()">上 传 伴 奏</el-button>
      </div>
    </div>
    <div class="mgSong">
      <el-radio-group v-model="tabPosition" style="width: 1134px">
        <el-radio-button label="song">我 的 歌 曲</el-radio-button>
        <el-radio-button label="silent">我 的 伴 奏</el-radio-button>
      </el-radio-group>
      <div style="display: flex;flex-wrap:wrap;" v-loading="listLoading">
        <Play :playMsg="item" v-for="item in songList"></Play>
        <div style="margin: 20px auto;padding: 0 365px">
          <el-pagination
            v-if="total!=0"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStyleType } from "@/api/shop";
import { getUserInfo, getLibrary } from "@/api/personal";
import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from "@/utils/localStorage"; //
import Play from "../components/play";
function isObject(obj) {
  return typeof obj == "object" && obj.constructor == Object;
}
export default {
  components: { Play },
  name: "myCenter",
  created() {
    getStyleType().then((res) => {
      setLocalStorage("getType", res.data);
    });
    this.getUser();
    this.getData(this.type, this.pageNum);
  },
  data() {
    return {
      userInfo: null,
      listLoading: false,
      pageNum: 1,
      pageSize: 12,
      total: 0,
      songList: [],
      isShow: false,
      tabPosition: "song",
      type: 0,
    };
  },
  watch: {
    tabPosition() {
      if (this.tabPosition == "song") {
        this.pageNum = 1;
        this.type = 0;
        this.getData(this.type, this.pageNum);
      } else {
        this.type = 1;
        this.pageNum = 1;
        this.getData(this.type, this.pageNum);
      }
    },
  },
  methods: {
    getUser() {
      let data;
      if (isObject(this.$store.state.user.userInfo)) {
        data = this.$store.state.user.userInfo;
      } else {
        data = JSON.parse(this.$store.state.user.userInfo);
      }
      let d = {
        userId: data.userId,
      };
      getUserInfo(d)
        .then((res) => {
          this.isShow = true;
          this.userInfo = res.data;
        })
        .catch((err) => {});
    },
    getData(isAccompany, page) {
      let data;
      if (isObject(this.$store.state.user.userInfo)) {
        data = this.$store.state.user.userInfo;
      } else {
        data = JSON.parse(this.$store.state.user.userInfo);
      }
      let d = {
        userId: data.userId,
        isAccompany: isAccompany,
        page: page,
      };
      this.listLoading = true;
      getLibrary(d)
        .then((res) => {
          this.listLoading = false;
          this.total = res.dataCount;
          this.songList = res.data;
        })
        .catch((err) => {
          this.listLoading = false;
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getData(this.type, val);
    },
    skipAccompany() {
      this.$router.push({ path: "/center/uploadAccompany" });
    },
    skipSong() {
      this.$router.push({ path: "/center/uploadSong" });
    },
  },
};
</script>

<style scoped lang="scss">
.myCenter {
  font-family: Tahoma, Arial, "Helvetica Neue", "Hiragino Sans GB", Simsun,
    sans-self;
  width: 1136px;
  height: auto;
  margin: 25px auto;
  .myMsg {
    width: 1131px;
    height: 217px;
    background-c: rgba(0, 0, 0, 1);
    border: 2px solid rgba(255, 255, 255, 0.55);
    position: relative;
    display: flex;
    .kailong {
      position: absolute;
      left: -42px;
      top: -10px;
      width: 0;
      height: 0;
      border-right: 65px solid transparent;
      border-left: 65px solid transparent;
      border-bottom: 65px solid #a3f310;
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg); /* IE 9 */
      -moz-transform: rotate(-45deg); /* Firefox */
      -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
      -o-transform: rotate(-45deg);
    }
  }
  .head_portrait {
    width: 172px;
    height: 172px;
    border-radius: 50% 50%;
    border: 2px solid #a3f310;
    margin: 22px 35px 22px 70px;
    overflow: hidden;
  }
  .user_msg {
    width: 360px;
    div {
      line-height: 37px;
    }
    .name {
      font-size: 30px;
      color: #a3f310;
      padding-top: 40px;
    }
    .address {
      font-size: 20px;
    }
    .signature {
      font-size: 20px;
    }
    .fans {
      font-size: 20px;
      span {
        padding-left: 15px;
        padding-right: 30px;
      }
    }
  }
  .mgSong {
    width: 1134px;
    height: auto;
    border: 1px solid rgba(181, 181, 181, 1);
    margin-top: 40px;
  }
}
</style>
<style lang="scss">
.myCenter {
  .el-radio-button {
    width: 566px;
  }
  .el-radio-button__inner {
    width: 100%;
    border-radius: 0;
  }
  .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 0;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0;
  }
  .el-radio-button__inner {
    background: rgba(89, 86, 86, 1);
    border: 1px solid rgba(181, 181, 181, 1);
    color: #fff;
    font-size: 20px;
  }
  .el-pagination {
    font-weight: lighter;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myCenter.vue